import { render, staticRenderFns } from "./SamplesPrintButtons.vue?vue&type=template&id=24585dae"
import script from "./SamplesPrintButtons.vue?vue&type=script&lang=js"
export * from "./SamplesPrintButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports